module Dashboard {
    "use strict";
    import EnvironmentsDataService = Shared.Environments.EnvironmentsDataService;
    import IEnvironmentData = Shared.Environments.IEnvironmentData;

    export function widgetEnvironmentsSelectorDirective(): ng.IDirective {
        return {
            restrict: "EA",
            scope: true,
            bindToController: { config: "=" },
            templateUrl: "widgetEnvironmentsSelectorTemplate.htm",
            controller: "widgetEnvironmentsSelectorController as ctrl"
        }
    }
    module.directive("frendsWidgetEnvironmentsSelector", [widgetEnvironmentsSelectorDirective]);

    export class WidgetEnvironmentsSelectorController {
        public config: IWidgetConfig;
        public availableEnvironments: string[] = [];

        static $inject = ["EnvironmentsDataService"];
        constructor(private environmentsDataService: EnvironmentsDataService) {
            this.environmentsDataService.all().then((envs: IEnvironmentData[]) => {
                this.availableEnvironments = _.map(envs, e => e.name);
            });
        }
    }
    module.controller("widgetEnvironmentsSelectorController", WidgetEnvironmentsSelectorController);
}